// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DoKTk {\n    margin: var(--m) 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n  }\n  ._6bVbn {\n    font-weight: normal;\n    margin-bottom: 0;\n    width: 312px;\n  }\n  .EQK7V {\n    position: relative;\n    z-index: 30;\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"AccountAttributeFilterDialog_topRow": "DoKTk",
	"AccountAttributeFilterDialog_sourceFilterLabel": "_6bVbn",
	"AccountAttributeFilterDialog_portal": "EQK7V"
};
export default ___CSS_LOADER_EXPORT___;
